// extracted by mini-css-extract-plugin
module.exports = {"wvm4gg4":"wvm4gg4","d1qadnsl":"d1qadnsl","l1enswin":"l1enswin","mr2l5ys":"mr2l5ys","hjm134z":"hjm134z"};